import { Button, Col, Container, Row, TextInput, Switch, } from 'react-materialize';

import M from 'materialize-css';
import Modal from './modal';
import React from 'react';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';
import { ErpConnect as qad } from '../../../services';
import './modal.css';
import axios from 'axios';
import debounce from 'lodash/debounce';

import AddressForm from "../../address/AddressForm";


class ModalNewCustomer extends React.Component {
  state = {
    loading: false,
    currentCustomer: null,
    selectedTerritory: null,
    shipOnStore: false,
    isCompany: false,
    haveFiscalData: false,
    shipAddressHasFiscal: false,
    name: '',
    email: '',
    salesPersonId: [],
    potential: '',
    user: [],
    typeId: '',
    phone: '',
    phoneTwo: '',
    zipcode: '',
    zipcodeShipping: '',
    address: '',
    addressShipping: '',
    rfc: '',
    rfcClient: [],
    territory: null,
    lastVisitDate: null,
    cities: [],
    userTerritories: [],
    citiesShipping: [],
    countryOption: null,
    countryShippingOption: null,
    stateOption: null,
    stateShippingOption: null,
    cityOption: null,
    cityShippingOption: null,
    neighboroodOption: null,
    territoryOption: null,
    neighborhoods: [],
    neighborhoodsShipping: [],
    clientsRelated: [],
    customerTypes: [],
    priceListOption: null,
    canEdit: false, 
    buttonDisabled: false,
    isInactive: false,
  };

  
  normalizePriceList = (val) => {
    const s = String(val || '').toUpperCase().trim();
    if (s === 'MAY' || s.startsWith('MAY')) return 'MAY';
    return 'MEN';
  };

  syncCustomerQAD = async () => {
    const { externalId } = this.state;

    if (!externalId) {
      console.warn('No existe externalId en el state');
      return;
    }

    try {
      const response = await axios.post('/api/customers/sync-qad', {
        external_id: externalId
      });

      const { error, message } = response.data;

      if (!error) {
        Swal.fire({
          icon: 'success',
          title: 'Sincronización exitosa',
          text: message || 'Cliente sincronizado correctamente',
          confirmButtonText: 'OK'
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message || 'No se pudo sincronizar el cliente'
        });
      }

    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: 'No fue posible sincronizar con QAD'
      });
    }
  };

  buscarRFC = async (rfc) => {

    if (rfc.length < 12 ||  rfc === this.state.currentCustomer?.billing_rfc) {
      this.setState({ rfcClient: [] });
      return;
    }
 
    try {
      this.setState({ buttonDisabled: true });
      const res = await fetch(`/api/clients/by-rfc?rfc=${rfc}`);
      const data = await res.json();

      this.setState({ rfcClient: data, buttonDisabled: false });

    } catch (error) {
      console.error(error);
    }

  };

  normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); 
  };

  getTerritoryOptionById = async (id) => {
    if (!id) return null;
    try {
      const opts = await this.loadTerritories('');
      return opts.find((o) => String(o.value) === String(id)) || null;
    } catch {
      return null;
    }
  };
  
  componentDidUpdate(prevProps) {
    if (
      prevProps.currentCustomer !== this.props.currentCustomer &&
      this.props.currentCustomer
    ) {
      const customer = this.props.currentCustomer;
  
      const territory = this.state.userTerritories.find(
        (t) => String(t.id) === String(customer.territory)
      );
  
      this.setState({
        currentCustomer: customer,
        potential: customer.potential || '',
        typeId: customer?.typeId || '',
        territoryOption: territory
          ? { value: String(territory.id), label: territory.name }
          : (customer?.territory
              ? { value: String(customer.territory), label: String(customer.typeId || 'Territorio') }
              : null),
      });
    }
  }
  
  async componentDidMount() {
    const { currentCustomer, user, catalog } = this.props;
    const isGerencia = ['001', '002', '008'].includes(String(user?.departmentId));
  
    const allTerritories = isGerencia
      ? (catalog?.territories || [])
      : (user?.territory || []);
  
    let territoryOption = null;
  
    if (currentCustomer?.territory) {
      const tLocal = allTerritories.find(t => String(t.id) === String(currentCustomer.territory));
      if (tLocal) {
        territoryOption = { value: String(tLocal.id), label: tLocal.name };
      } else {
        if (currentCustomer?.typeId) {
          territoryOption = { value: String(currentCustomer.territory), label: String(currentCustomer.typeId) };
        } else {
          territoryOption = await this.getTerritoryOptionById(currentCustomer.territory);
        }
      }
    }
  
    let canEdit = false;
    if (currentCustomer) {
      const isCreator =
        String(currentCustomer.distributionChannel || '').trim().toUpperCase() ===
        String(user?.salesPersonId || '').trim().toUpperCase();
      const isSameTerritory =
        !!currentCustomer.territory &&
        (user?.territory || []).some((t) => String(t.id) === String(currentCustomer.territory));
      canEdit =
        isGerencia ||
        isCreator ||
        isSameTerritory ||
        (user?.salesPersonId === 'VYAM' || user?.salesPersonId === 'VBET');
    }
      
    this.setState(
      {
        currentCustomer,
        userTerritories: allTerritories,
        potential: currentCustomer?.potential || '',
        typeId: currentCustomer?.typeId || '',
        territoryOption,
        lastVisitDate: currentCustomer?.lastVisitDate ? new Date(currentCustomer.lastVisitDate) : null,
        canEdit
      },
      () => M.updateTextFields()
    );
  }
 
  handleChange = (e) => {
    this.setState({
      numCustomer: e.target.value,
    });
  };

  handleCloseModal = () => {
    this.setState({
      loading: false,
      currentCustomer: null,
      isInactive: false,
      shipOnStore: false,
      isCompany: false,
      haveFiscalData: false,
      shipAddressHasFiscal: false,
      name: '',
      email: '',
      phone: '',
      phoneTwo: '',
      zipcode: '',
      zipcodeShipping: '',
      address: '',
      addressShipping: '',
      rfc: '',
      cities: [],
      territory: null,
      lastVisitDate: null,
      citiesShipping: [],
      countryOption: null,
      countryShippingOption: null,
      stateOption: null,
      stateShippingOption: null,
      cityOption: null,
      cityShippingOption: null,
      neighboroodOption: null,
      territoryOption: null,
      priceListOption: null,
      neighborhoods: [],
      neighborhoodsShipping: [],
      clientsRelated: [],
      customerTypes: [],
      canEdit: false,
    
    });
    this.props.onClose();
  };
  
  onToggleShipSameAsFiscal = (checked) => {
    this.setState((prev) => {
      if (!checked) {
        return { shipAddressHasFiscal: false };
      }
      //console.log('prev', prev);
      return {
            shipAddressHasFiscal: true,
        
          // Copiar fiscal → shipping
          neighborhoodShippingOption: prev.neighborhoodOption,
          numberAddressShipping: prev.numberAddress,
          zipcode: prev.zipcode,
          addressShipping: prev.address,
          zipcodeShipping: prev.zipcode,
          citiesShipping: prev.cityOption,
          stateShippingOption: prev.stateOption,
          countryShippingOption: prev.countryOption,
 
      };
    });
  };
  
  
  handleCreateCustomer = async () => {
    this.setName(this.state);
    let validate = false;
    if (this.state.isCompany) {
      if (this.state.name !== '' && this.state.email !== '' && this.state.phone !== '') {
        validate = true;
      } else {
        Swal.fire({
          title: 'La empresa debe tener un nombre, un email y un telefono obligatoriamente',
        });
        return;
      }
    } else {
      if (this.state.name !== '' && this.state.email !== '') {
        validate = true;
      } else {
        Swal.fire({
          title: 'El cliente debe tener un nombre, apellido paterno, apellido materno y e-mail',
        });
        return;
      }
    }
    if (!this.state.customerTypes || this.state.customerTypes.length <= 0) {
      Swal.fire({
        title: 'El cliente debe tener tipo seleccionado',
      });
      return;
    }
    if (!this.state.priceListOption || !this.state.priceListOption.value) {
      Swal.fire({
        title: 'El cliente debe tener lista de precios seleccionada',
      });
      return;
    }
    const emailValidator = new RegExp(
      "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
    );

    if (this.state.email !== '' && !emailValidator.test(this.state.email)) {
      Swal.fire({
        title: 'El cliente debe tener un e-mail bien formado (ej. nombre@dominio.{extension})',
      });
      return;
    }
    const user = JSON.parse(localStorage.getItem('user'));
    //console.log(' this.state.priceListOption?.label ',  this.state.priceListOption?.label );
    const customerData = {
      extId: this.state.externalId || Date.now(),
      name: this.state.name || '',
      site: user.site,
      email: this.state.email || '',
      phone: this.state.phone || '',
      tel2: this.state.phoneTwo || '',

      customerType: this.state.customerTypes
      ? this.state.customerTypes.map(t => t.value).join(',')
      : '',

      pricesList: this.normalizePriceList(
      this.state.priceListOption?.label || 'MEN'
      ),

      distributionChannel:
      this.props.user?.salesPersonId ||
      JSON.parse(localStorage.getItem('user'))?.salesPersonId ||
      '',
      territory: this.state.territory || null,
      type_id: this.state.territoryOption?.label || 'Sin territorio',

      isInactive: !!this.state.isInactive,
      isCompany: !!this.state.isCompany,

      billingRfc: (this.state.rfc || '').replaceAll('-', ''),
      lastVisitDate: '',
      billingCountry: '',
      billingState: '',
      billingCity: '',
      billingMunicipality: '',
      billingNeighborhood: '',
      billingZipcode: '',
      billingAddress: '',

      country: '',
      potential: '',
      state: '',
      city: '',
      municipality: '',
      neighborhood: '',
      zipcode: '',
      address: '',
    };

    if (this.state.haveFiscalData) {
      /*
      console.group('VALIDACIÓN DATOS FISCALES');
        console.log('customerData:', customerData);
      console.groupEnd();
        console.log('state:', this.state);
        */
      
     if (
        (
          this.state.countryOption &&
          this.state.stateCustomer &&
          this.state.cityCustomer &&
          this.state.selectedNeighborhoodOption &&
          this.state.zipcode !== '' &&
          this.state.address !== '' &&
          this.state.rfc !== ''
        ) ||
        (this.state.rfc !== '' && this.state.currentCustomer != null)
      ){
        const rfcValidator = new RegExp('^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$');
        const zipcodeValidator = new RegExp('^[0-9]{5}$');
        if (!this.state.currentCustomer) {
          if (rfcValidator.test(this.state.rfc) && zipcodeValidator.test(this.state.zipcode)) {
            validate = true;
          } else {
            Swal.fire({
              title: 'El cliente debe tener un codigo postal y un RFC valido',
            });
            return;
          }
        } else {
          if (rfcValidator.test(this.state.rfc)) {
            validate = true;
          } else {
            Swal.fire({
              title: 'El cliente debe tener un RFC valido',
            });
            return;
          }
        }
        if (!this.state.currentCustomer) {
          // console.log('Si tiene datos de facturación');

          customerData['billingCountry'] = this.state.countryOption.label;
          customerData['billingState'] = this.state.stateCustomer.label;
          customerData['billingCity'] = this.state.cityCustomer.label;
          customerData['billingNeighborhood'] = this.state.selectedNeighborhoodOption.label.substring(0, 20); 
          customerData['billingMunicipality'] = this.state.selectedNeighborhoodOption.label.substring(0, 20);
          customerData['billingZipcode'] = this.state.zipcode;
          customerData['billingAddress'] = this.state.address + ' #' + this.state.numberAddress;
          if (this.state.shipAddressHasFiscal){
           // console.log('Usando datos fiscales como dirección de envío');

            customerData['country'] = customerData['billingCountry'];
            customerData['state'] = customerData['billingState'];
            customerData['city'] = customerData['billingCity'];
            customerData['neighborhood'] = customerData['billingNeighborhood'];
            customerData['municipality'] = customerData['billingMunicipality'];
            customerData['zipCode'] = customerData['billingZipcode'];
            customerData['address'] = customerData['billingAddress'];
          }
        }
        customerData['billingRfc'] = this.state.rfc;
        customerData['lastVisitDate'] = this.state.lastVisitDate;
        customerData['potential'] = this.state.potential;
        if (this.currentCustomer) {
          const clientsWithSameRfc = this.clients.filter((cl) => {
            return cl.billingRfc.toUpperCase() === this.state.rfc.toUpperCase();
          });
          if (clientsWithSameRfc.length > 0) {
            Swal.fire({
              title: 'Ya existe el cliente con RFC: ' + this.state.rfc,
            });
            return;
          }
        }
      } else {
        Swal.fire({
          title: 'El cliente debe tener una ciudad, un estado, un pais, una dirección, un codigo postal y un RFC',
        });
        return;
      }
    }

    if (!this.state.shipAddressHasFiscal) {
      if (!this.state.shipOnStore) {
        if (
          this.state.countryShippingOption &&
          this.state.stateShippingOption &&
          this.state.cityShippingOption &&
          this.state.neighborhoodShippingOption &&
          this.state.zipcodeShipping !== '' &&
          this.state.addressShipping !== ''
        ) {

          customerData['country'] = this.state.countryShippingOption.label;
          customerData['state'] = this.state.stateShippingOption.label;
          customerData['city'] = this.state.cityShippingOption.label;
          customerData['neighborhood'] = this.state.neighborhoodOption.label.substring(0, 20);
          customerData['municipality'] = this.state.neighborhoodOption.label.substring(0, 20);
          customerData['zipCode'] = this.state.zipcodeShipping;
          customerData['address'] = this.state.addressShipping + ' #' + this.state.numberAddressShipping;
          customerData['lastVisitDate'] = this.state.lastVisitDate;
          customerData['potential'] = this.state.potential;
          if (!customerData['billingCountry']) {
           // console.log('sin datos fiscales de envio, asignando datos de envio a facturación');
            customerData['billingCountry'] = this.state.countryShippingOption.label;
            customerData['billingState'] = this.state.stateShippingOption.label;
            customerData['billingCity'] = this.state.cityShippingOption.label;
            customerData['billingNeighborhood'] = this.state.neighborhoodOption.label.substring(0, 20);
            customerData['billingMunicipality'] = this.state.neighborhoodOption.label.substring(0, 20);
            customerData['billingZipCode'] = this.state.zipcodeShipping;
            customerData['billingAddress'] = this.state.addressShipping + ' #' + this.state.numberAddressShipping;
          }
        } else {
          //console.log('customerData before Swal:', customerData);
          //console.log('customerData before Swal:', this.state);
          Swal.fire({
            title: 'El cliente debe tener una ciudad, un estado, un pais, una dirección, un codigo postal para el envio',
          });
          return;
        }
      }
    } 

    if (validate) {
      Swal.fire({
        title: (!this.state.currentCustomer ? 'Creando' : 'Modificando') + ' cliente',
        showCloseButton: false,
        allowOutsideClick: () => !Swal.isLoading(),
        didOpen: () => {
          Swal.showLoading();
        },
      });

const userEffective =
  this.props.user || JSON.parse(localStorage.getItem('user')) || {};

const isGerencia = ['001', '002', '008'].includes(String(userEffective?.departmentId));

const isCreator =
  String(this.state.currentCustomer?.distributionChannel || '')
    .trim()
    .toUpperCase() ===
  String(userEffective?.salesPersonId || '')
    .trim()
    .toUpperCase();

    const isSuperEditor = String(userEffective?.salesPersonId) === 'VYAM' || String(userEffective?.salesPersonId) === 'VBET';
  
const extractTid = (t) =>
  t == null
    ? null
    : String(
        t.id ?? t.value ?? t.territory ?? t.territoryId ?? t.territory_id ?? t
      ).trim();

const userTerritoryIds = (userEffective?.territory || this.state.userTerritories || [])
  .map(extractTid)
  .filter(Boolean);

const territoryIdForPerm = extractTid(
  (this.state.territoryOption && this.state.territoryOption.value) ||
    this.state.territory ||
    this.state.currentCustomer?.territory ||
    ''
);

const isSameTerritory =
  !!territoryIdForPerm && userTerritoryIds.includes(String(territoryIdForPerm));

const canEdit = !!(isGerencia || isCreator || isSameTerritory || isSuperEditor);
      const territoryIdToSend =
        (this.state.territoryOption && this.state.territoryOption.value) ||
        this.state.territory ||
        this.state.currentCustomer?.territory ||
        null;

      if (territoryIdToSend !== null && String(territoryIdToSend).trim() !== '') {
        customerData.territory = String(territoryIdToSend).trim();
      }
      if (this.state.currentCustomer && !canEdit) {
        Swal.close();
        Swal.fire({
          title: 'Sin permisos',
          text: 'No puedes modificar este cliente (creador / gerencia / mismo territorio).',
        });
        return;
      }
      if (canEdit) {
        if (this.state.potential && Number(this.state.potential) > 0) {
          customerData.potential = parseFloat(this.state.potential);
        }

        if (this.state.lastVisitDate) {
          const d0 =
            this.state.lastVisitDate instanceof Date
              ? this.state.lastVisitDate
              : new Date(this.state.lastVisitDate);
          const d = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate());
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          customerData.lastVisitDate = `${y}-${m}-${day}`;
        }
        customerData.pricesList = this.normalizePriceList(
          this.state.priceListOption?.value || customerData.pricesList
        );
      }
      
      if (this.state.currentCustomer) {
        customerData['isInactive'] = this.state.isInactive;
        const client = await qad.catalog.customer.updateBasic(this.state.currentCustomer.value, customerData);
        // console.log('prueba', customerData);
        
        // console.log('this.state', this.state);

        Swal.close();
        if (client) {
          await fetch('/api/customers/sync', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(customerData),
          });

          customerData['id'] = this.state.currentCustomer.value;
          this.setState({ numCustomer: customerData['id'] });
          const indexClient = this.props.catalog.customers.findIndex(
            (cl) => cl.id === this.state.currentCustomer.value
          );
          const indexInactive = this.props.catalog.inactiveCustomers.findIndex(
            (cl) => cl.id === this.state.currentCustomer.value
          );
          if (indexClient !== -1) {
            this.props.catalog.customers[indexClient] = customerData;
          } else {
            this.props.catalog.customers.push(customerData);
          }
          if (indexInactive !== -1) {
            this.props.catalog.inactiveCustomers.splice(indexInactive, 1);
          }
          this.handleCloseModal();
          M.toast({
            html: `Se Actualizó el cliente con ID: ${customerData['id']}`,
            classes: 'message-danger',
          });
        } else {
          M.toast({
            html: 'No se actualizó el cliente',
            classes: 'message-danger',
          });
        }
      } else {
       // console.log(customerData);
        if (customerData['billingState'] === 'COAHUILA DE ZARAGOZA') {
          customerData['billingState'] = 'COAHUILA';  
        }
        if (customerData['billingState'] === 'MEXICO') {
          customerData['billingState'] = 'ESTADO DE MEXICO';  
        }
        const client = await qad.catalog.customer.create(customerData);
        Swal.close();
        if (client) {
          customerData.extId = String(client.id);
           await fetch('/api/customers/sync', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(customerData),
          });
          this.setState({ numCustomer: client.id });
          this.props.catalog.customers.push(customerData);
          this.handleCloseModal();
          M.toast({
            html: `Se creó cliente con ID: ${client.id}`,
            classes: 'message-danger',
          });
        } else {
          M.toast({
            html: 'No se creó el cliente',
            classes: 'message-danger',
          });
        }
      }
    } else {
      M.toast({
        html: 'No se creó el cliente',
        classes: 'message-danger',
      });
    }
  };
  
  filterStates = (inputValue) => {
    if (inputValue.length > 2) {
      this.filtredStates = this.states.filter((i) => {
        return i.label.toLowerCase().includes(inputValue.toLowerCase());
      });
    } else {
      this.filtredStates = this.states.slice(0, 500).filter((i) => {
        return i.label.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    return this.filtredStates;
  };

  promiseStates = (inputValue) => {
    return new Promise((resolve) => {
      resolve(this.filterStates(inputValue));
    });
  };

  filterCountries = (inputValue) => {
    if (inputValue.length > 2) {
      this.filtredCountries = this.countries.filter((i) => {
        return i.label.toLowerCase().includes(inputValue.toLowerCase());
      });
    } else {
      this.filtredCountries = this.countries.slice(0, 500).filter((i) => {
        return i.label.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    return this.filtredCountries;
  };

  promiseCountries = (inputValue) => {
    return new Promise((resolve) => {
      resolve(this.filterCountries(inputValue));
    });
  };

  filterCities = (inputValue) => {
    let filtredCities = [];
    if (!this.state.isOnShipping) {
      if (inputValue.length > 2) {
        filtredCities = this.state.citiesShipping.filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      } else {
        filtredCities = this.state.citiesShipping.slice(0, 500).filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      }
    } else {
      if (inputValue.length > 2) {
        filtredCities = this.state.cities.filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      } else {
        filtredCities = this.state.cities.slice(0, 500).filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      }
    }
    return filtredCities;
  };

  promiseCities = (inputValue) => {
    return new Promise((resolve) => {
      resolve(this.filterCities(inputValue));
    });
  };

  filterNeighborhoods = (inputValue) => {
    let filtred = [];
    if (!this.state.isOnShipping) {
      if (inputValue.length > 2) {
        filtred = this.state.neighborhoods.filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      } else {
        filtred = this.state.neighborhoods.slice(0, 500).filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      }
    } else {
      if (inputValue.length > 2) {
        filtred = this.state.neighborhoodsShipping.filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      } else {
        filtred = this.state.neighborhoodsShipping.slice(0, 500).filter((i) => {
          return i.label.toLowerCase().includes(inputValue.toLowerCase());
        });
      }
    }
    return filtred;
  };

  loadTerritories = async (inputValue) => {
    try {
      const res = await axios.get(
        'http://miplayera2.dyndns.org:8810/gmpPlatforms/rest/customer/territory?id='
      );
      const data = res.data?.read?.[0]?.data || [];

      const filtered = inputValue
        ? data.filter((t) => t.name.toLowerCase().includes(inputValue.toLowerCase()))
        : data;

      const options = filtered.map((t) => ({
        value: String(t.id),
        label: t.name,
      }));

      if (!this.state.territoryOption && this.state.currentCustomer?.territory) {
        const found = options.find(
          (opt) => String(opt.value) === String(this.state.currentCustomer.territory)
        );
        if (found) {
          this.setState({ territoryOption: found });
        }
      }

      return options;
    } catch (error) {
      console.error('Error cargando territorios:', error);
      return [];
    }
  };

  promiseNeighborhoods = (inputValue) => {
    return new Promise((resolve) => {
      resolve(this.filterNeighborhoods(inputValue));
    });
  };

  assignCountry = (value, isShipping = false) => {
    if (value) {
      if (!isShipping) {
        this.setState({
          countryOption: value,
        });
      } else {
        this.setState({
          countryShippingOption: value,
        });
      }
    } else {
      if (!isShipping) {
        this.setState({
          countryOption: value,
        });
      } else {
        this.setState({
          countryShippingOption: value,
        });
      }
    }
  };

  assignState = (value, isShipping = false) => {
    if (!value) {
      if (isShipping) {
        this.setState({
          stateOption: value,
        });
      } else {
        this.setState({
          stateShippingOption: value,
        });
      }
      return;
    }
    if (!isShipping) {
      this.setState({
        stateOption: value,
        cities: this.fullCities.filter((item) => item.stateId === value.value),
        cityOption: null,
      });
    } else {
      this.setState({
        stateShippingOption: value,
        citiesShipping: this.fullCities.filter((item) => item.stateId === value.value),
        cityShippingOption: null,
      });
    }
  };

  assignCities = async (value, isShipping = false) => {
    if (!value) {
      if (!isShipping) {
        this.setState({
          cityOption: null,
          neighborhoodOption: null,
          zipcode: '',
        });
      } else {
        this.setState({
          cityShippingOption: null,
          neighborhoodShippingOption: null,
          zipcodeShipping: '',
        });
      }
      return;
    }
    Swal.fire({
      title: 'Cargando Colonias',
      showCloseButton: false,
      allowOutsideClick: () => !Swal.isLoading(),
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const neighborhoods = await qad.catalog.website.getNeighborhoods(value.value);
    if (!isShipping) {
      this.setState({
        cityOption: value,
        neighborhoods: neighborhoods.map((item) => {
          return { label: item.label , value: item.zip, zipcode: item.zip };
        }),
        neighborhoodOption: null,
        zipcode: '',
      });
    } else {
      this.setState({
        cityShippingOption: value,
        neighborhoodsShipping: neighborhoods.map((item) => {
          return { label: item.label, value: item.zip, zipcode: item.zip };
        }),
        neighborhoodShippingOption: null,
        zipcodeShipping: '',
      });
    }
    Swal.close();
  };

  assignNeigborhoods = async (value, isShipping = false) => {
    if (!value) {
      if (!isShipping) {
        this.setState({
          neighborhoodOption: null,
        });
      } else {
        this.setState({
          neighborhoodShippingOption: null,
        });
      }
      return;
    }
    if (!isShipping) {
      this.setState({
        neighborhoodOption: value,
        zipcode: value.zipcode,
      });
    } else {
      this.setState({
        neighborhoodShippingOption: value,
        zipcodeShipping: value.zipcode,
      });
    }
  };

  setName = async (datas) => {
    await this.setState(datas);

    let clients = [];
    if (this.state.name !== null && this.state.name !== '') {
      clients = this.clients.filter((client) => {
        return client.name.toLowerCase().includes(this.state.name.toLowerCase());
      });
    }
    this.setState({
      clientsRelated: clients.splice(0, 3),
    });
  };

  promiseTerritories = (inputValue) => {
    const { userTerritories } = this.state;

    const filtered = userTerritories
      .filter((t) => t.name.toLowerCase().includes(inputValue.toLowerCase()))
      .map((t) => ({
        value: t.id,
        label: t.name,
      }));

    return Promise.resolve(filtered);
  };

  promiseCustomers = debounce((inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      this.setState({ noResults: false });
      callback([]);
      return;
    }

    axios.get('/api/clients/search', {
      params: { 
        q: inputValue, 
        includeInactive: 1 
      },
    })
    .then(res => {
      this.setState({ noResults: res.data.length === 0 });
      callback(res.data);
    })
    .catch(() => {
      this.setState({ noResults: true });
      callback([]);
    });
  }, 1000);
  
  selectCustomerToUpdate = async (customer) => {
    const normalizeDate = (d) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const parseYMD = (s) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s).trim());
      if (!m) return null;
      return normalizeDate(new Date(+m[1], +m[2] - 1, +m[3]));
    };

    const parseSlashYY = (s) => {
      const m = /^(\d{2})\/(\d{2})\/(\d{2})$/.exec(String(s).trim());
      if (!m) return null;
      const a = +m[1], b = +m[2], y = 2000 + +m[3];
      let mm, dd;
      if (a > 12 && b <= 12) { dd = a; mm = b; }
      else if (b > 12 && a <= 12) { dd = b; mm = a; }
      else { mm = a; dd = b; }
      return normalizeDate(new Date(y, mm - 1, dd));
    };

    const parseFromApi = (v) => {
      if (!v) return null;
      if (v instanceof Date) return normalizeDate(v);
      return parseYMD(v) || parseSlashYY(v) || normalizeDate(new Date(v));
    };

    const resolveTerritory = (valueFromApi, labelHint) => {
      const territories = this.state.userTerritories || [];
      const val = valueFromApi != null ? String(valueFromApi) : '';

      const byId = territories.find((t) => String(t.id) === val);
      if (byId) {
        return { id: val, option: { value: String(byId.id), label: byId.name } };
      }

      if (val && isNaN(Number(val))) {
        const byName = territories.find(
          (t) => t.name.toLowerCase().trim() === val.toLowerCase().trim()
        );
        if (byName) {
          return {
            id: String(byName.id),
            option: { value: byName.id, label: byName.name },
          };
        }
      }

      if (val && labelHint) {
        return { id: val, option: { value: val, label: String(labelHint) } };
      }

      return { id: null, option: null };
    };

    const normalizeClient = (c) => ({
      id: c.id,
      externalId: c.external_id || c.extId,
      name: c.name,
      email: c.email,
      phone: c.phone,
      pricesList: c.prices_list || c.pricesList,
      customerType: c.customer_type || c.customerType,
      billingRfc: c.billing_rfc || c.billingRfc,
      isInactive: c.is_inactive ?? c.isInactive,
      potential: c.potential,
      lastVisitDate: c.last_visit_date || c.lastVisitDate,
      territory: c.territory,
      distributionChannel: c.distribution_channel || c.distributionChannel,
      typeId: c.type_id || c.typeId || c.region,
    });

    if (!customer || !customer.id) {
      this.resetCustomerForm();
      return;
    }

    const mapPriceListToOption = (apiValue) => {
      
      if (!apiValue) return this.priceLists?.[0] || null;

      const normalized = String(apiValue).toUpperCase().trim();

      if (normalized.includes('MAY')) {
        return this.priceLists.find(p => p.value === 'MAY');
      }

      return this.priceLists.find(p => p.value === 'MEN');
    };

    const client = normalizeClient(customer);

    const priceListSelected = mapPriceListToOption(client.pricesList);

    const clientTypes = client.customerType
      ? client.customerType.split(',')
      : [];

    const { id: territoryId, option: territoryOption } =
      resolveTerritory(client.territory, client.typeId);

    const user = this.props.user || JSON.parse(localStorage.getItem('user')) || {};

    const computeCanEdit = (distributionChannel, territoryId) => {
      const isGer = ['001', '002'].includes(String(user?.departmentId));
      const isCre =
        String(distributionChannel || '').trim().toUpperCase() ===
        String(user?.salesPersonId || '').trim().toUpperCase();

      const userTids = (user?.territory || [])
        .map((t) => String(t.id))
        .filter(Boolean);

      const sameTerritory = !!territoryId && userTids.includes(String(territoryId));
      const isSuper =
        user?.salesPersonId === 'VYAM' || user?.salesPersonId === 'VBET' || user?.salesPersonId === 'VDAP';
      
      return isGer || isCre || sameTerritory || isSuper;
    };

    this.setState({
      currentCustomer: customer,
      externalId: client.externalId,
      rfcClient: [],
      haveFiscalData: true,
      shipOnStore: true,
      isInactive: !!client.isInactive,
      name: client.name || '',
      email: client.email || '',
      phone: client.phone || '',
      priceListOption: priceListSelected || this.priceLists?.[0] || null,
      customerTypes: client.customerType
        ? this.customerTypes.filter((t) => clientTypes.includes(t.value))
        : null,

      rfc: (client.billingRfc || '').replaceAll('-', ''),
      potential: client.potential ?? 0,
      lastVisitDate: client.lastVisitDate
        ? parseFromApi(client.lastVisitDate)
        : null,

      territory: territoryId,
      territoryOption,

      loadingCustomer: false,
      errorCustomer: null,
      canEdit: computeCanEdit(client.distributionChannel, territoryId),
    });
  };

  render() {
    const isGerencia = ['001', '002', '008'].includes(String(this.props.user.departmentId));
    
    const isCreator =
      String(this.state.currentCustomer?.distributionChannel || '').trim() ===
        String(this.props.user.salesPersonId || '').trim() &&
      this.props.user.salesPersonId !== '006';
      const isSuperEditor = this.props.user?.salesPersonId === 'VYAM' || this.props.user?.salesPersonId === 'VBET';
        const canEdit = this.state.canEdit || isSuperEditor;

    this.countries = this.props.catalog.geography.countries.map((item) => {
      return { label: item.label, value: item.id };
    });
    this.states = this.props.catalog.geography.states.map((item) => {
      return { label: item.label, value: item.id };
    });
    this.fullCities = this.props.catalog.geography.cities.map((item) => {
      return { label: item.label, value: item.id, stateId: item.state_id };
    });
    this.customerTypes = this.props.catalog.customerTypes.map((item) => {
      return { label: item.name, value: item.id };
    });
    this.priceLists = [
      { label: 'Menudeo', value: 'MEN' },
      { label: 'Mayoreo', value: 'MAY' },
    ];
    this.clients = [...this.props.catalog.customers, ...this.props.catalog.inactiveCustomers];
    this.filtredClients = this.props.catalog.customers;

    if (isCreator) {
      
      console.log("El usuario es el creador.");
    }
    /*
    this.customers = this.clients.map((el) => {
      return {
        value: el.id,
        label: el.id + ' - ' + el.name + ' - ' + el.billingRfc,
        priceList: this.state.currentCustomer?.pricesList,
        distributionChannel: el.distributionChannel,
        territory: el.territory,
        potential: el.potential,
        lastVisitDate: el.lastVisitDate,
        typeId: el.typeId,
      };
    });
    */
    return (

      <React.Fragment>
        <Modal isOpen={this.props.isOpen} onClose={this.handleCloseModal}>
          <Container>

            <Row>
              <Col s={12}>
                <h3 className="m3">
                  {' '}
                  {this.state.currentCustomer != null ? 'Modificar' : 'Crear'} Cliente
                </h3>
                <Row>
                <Col
                  s={12}
                  className="margin"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <AsyncSelect
                      placeholder="Clientes"
                      cacheOptions
                      isClearable
                      value={this.currentCustomer}
                      onChange={(value) => {
                        this.selectCustomerToUpdate(value);
                        this.setState({ inputValue: '' });
                      }}
                      loadOptions={this.promiseCustomers}
                      loadingMessage={() => 'Buscando clientes...'}
                      noOptionsMessage={() =>
                        this.state.noResults
                          ? 'No se encontró ningún resultado'
                          : 'Escribe nombre o numero de Cliente'
                      }
                    />
                  </div>

                </Col>
                  <Col className="p-bottom s4 l3 offset-l1">&nbsp;</Col>
                  <Col className="p-bottom s4 l3 offset-l1 hide">
                    <label> ¿Es empresa? </label>
                    <Switch
                      id="isCompanyCustomer"
                      onLabel={'Si'}
                      offLabel={'No'}
                      checked={this.state.isCompany}
                      onChange={(e) => this.setState({ isCompany: e.target.checked })}
                    />
                  </Col>
                  {!this.state.currentCustomer ? (
                    [
                      <Col key="haveFiscalDataCustomerCol" className="p-bottom s4 l3 offset-l1">
                        <label> ¿Requiere Factura? </label>
                        <Switch
                          id="haveFiscalDataCustomer"
                          onLabel={'Si'}
                          offLabel={'No'}
                          checked={this.state.haveFiscalData}
                          onChange={(e) => this.setState({ haveFiscalData: e.target.checked })}
                        />
                      </Col>,
                      <Col key="shipOnStoreCustomerCol" className="p-bottom s4 l3 offset-l1">
                        <label> Entrega en Tienda </label>
                        <Switch
                          id="shipOnStoreCustomer"
                          onLabel={'Si'}
                          offLabel={'No'}
                          checked={this.state.shipOnStore}
                          onChange={(e) => this.setState({ shipOnStore: e.target.checked })}
                        ></Switch>
                      </Col>,
                    ]
                  ) : (
                    <Col className="p-bottom s4 l3 offset-l1">
                      <label> ¿Activar? </label>
                      <Switch
                        id="isInactive"
                        onLabel={'Si'}
                        offLabel={'No'}
                        checked={!this.state.isInactive}
                        onChange={(e) => this.setState({ isInactive: !e.target.checked })}
                      ></Switch>
                    </Col>
                  )}
                  <Col s={12} l={6} className="p-bottom">
                    <TextInput
                      id="nameCustomer"
                      s={12}
                      value={this.state.name}
                      label={!this.state.isCompany ? 'Nombre y Apellidos' : 'Razón Social'}
                      onChange={(e) => this.setName({ name: e.target.value })}
                    />
                  </Col>
                  <Col s={12} l={6} className="p-bottom">
                    <TextInput
                      id="emailCustomer"
                      s={12}
                      type={'email'}
                      value={this.state.email}
                      label="E-mail"
                      onChange={(e) => this.setState({ email: e.target.value })}
                    />
                  </Col>
                  <Col s={12} l={6} className="p-bottom">
                    <TextInput
                      id="phoneCustomer"
                      s={12}
                      type={'tel'}
                      value={this.state.phone}
                      label="Telefono"
                      onChange={(e) => this.setState({ phone: e.target.value })}
                    />
                  </Col>
                  <Col s={12} l={6} className="p-bottom">
                    <AsyncSelect
                      id="customerType"
                      placeholder="Tipo de Cliente"
                      cacheOptions
                      isClearable
                      isMulti
                      value={this.state.customerTypes}
                      onChange={(value) => this.setState({ customerTypes: value })}
                      defaultOptions={this.customerTypes}
                    />
                  </Col>

                  {this.state.currentCustomer && (
                    <>
                      {isGerencia ? (
                        <>
                          <Col s={12} l={3} className="p-bottom">
                            <AsyncSelect
                              id="priceList"
                              placeholder="Lista de precios"
                              cacheOptions
                              isClearable
                              value={this.state.priceListOption}
                              onChange={(value) => this.setState({ priceListOption: value })}
                              defaultOptions={this.priceLists}
                            />
                          </Col>
                          <Col
                            s={12}
                            l={3}
                            className="p-bottom"
                            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                          >
                            <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: 0 }}>
                              Lista de precios: {this.state.priceListOption?.label || ''}
                            </p>

                            <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: 0 }}>
                              Territorio: {this.state.territoryOption?.label || 'Sin territorio'}
                            </p>
                          </Col>
                          <Col>
                           <Button
                              className="m3"
                              node="button"
                              waves="light"
                              style={{ zIndex: 0 }}
                              title="Sincronizar Dirección del Cliente con QAD"
                              onClick={this.syncCustomerQAD}
                            >
                              Sincronizar Dirección 
                            </Button>
                          </Col>
                        </>
                      ) : (
                        <Col
                          s={12}
                          l={6}
                          className="p-bottom"
                          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                        >
                          <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: 0 }}>
                            Lista de precios: {this.state.priceListOption?.label || ''}
                          </p>
                          <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: 0 }}>
                            Territorio: {this.state.territoryOption?.label || 'Sin territorio'}
                          </p>
                            <Button
                              className="m3"
                              node="button"
                              waves="light"
                              style={{ zIndex: 0 }}
                              title="Sincronizar Dirección del Cliente con QAD"
                              onClick={this.syncCustomerQAD}
                            >
                              Sincronizar Dirección 
                            </Button>
                        </Col>          
                      )}
                    </>
                  )}

                  <Col s={12} l={6} className="p-bottom" style={{ display: !this.state.currentCustomer ? '' : 'none' }}>
                    <AsyncSelect
                      id="priceList"
                      placeholder="Lista de precios"
                      cacheOptions
                      isClearable
                      value={this.state.priceListOption}
                      onChange={(value) => this.setState({ priceListOption: value })}
                      defaultOptions={this.priceLists}
                    />
                  </Col>
                  <Col s={12} style={{ display: this.state.clientsRelated.length > 0 ? '' : 'none' }}>
                    <Row>
                      <Col s={12}>
                        <span s={12}>Clientes en sistema</span>
                      </Col>
                      <Col s={12}>
                        {this.state.clientsRelated.map((client, idx) => {
                          return (
                            <React.Fragment key={idx + '_' + client.id}>
                              <Col s={12} l={4}>
                                <div>
                                  <label>Cliente:&nbsp;</label>
                                  <span>
                                    {client.name}, RFC: {client.billingRfc}
                                  </span>
                                </div>
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </Col>
                    </Row>
                  </Col>
                  <Col s={12} style={{ display: !this.state.haveFiscalData ? 'none' : '' }}>
                    <h4 s={12}>Datos Fiscales</h4>
                  </Col>
                  <Col s={12} l={6} className="p-bottom" style={{ display: !this.state.haveFiscalData ? 'none' : '' }}>
                    <TextInput
                      id="rfcCustomer"
                      s={12}
                      type={'text'}
                      value={this.state.rfc}
                      label="RFC"
                      onChange={(e) => { 
                          const rfc = e.target.value.toUpperCase();
                          this.setState({ rfc });
                          this.buscarRFC(rfc);
                      }}
                    />
                    {
                        this.state.rfcClient.length > 0 && (
                          <div style={{color:'red', marginTop:'5px'}}>
                            <b>Este RFC ya existe:</b>

                            <ul>
                              {this.state.rfcClient.map((c, i) => (
                                <li key={i}>
                                  {c.external_id} - {c.name}
                                </li>
                              ))}
                            </ul>

                          </div>
                        )
                      }
                  {this.state.currentCustomer == null && (
                    <TextInput
                      id="numberAddressCustomer"
                      s={12}
                      value={this.state.numberAddress}
                      label="Número Exterior"
                      onChange={(e) => {
                        this.setState({ numberAddress: e.target.value });
                      }}
                    />
                  )}
                 </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >
                    <TextInput
                      id="addressCustomer"
                      s={12}
                      value={this.state.address}
                      label="Dirección"
                      onChange={(e) => this.setState({ address: e.target.value })}
                    />
                 
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >
              
                     <AddressForm
                      onChange={(data) => {
                          if (data) {
                            const coloniasOptions = data.colonias.map(c => ({
                              label: c,
                              value: c
                            }));
                            coloniasOptions.push({
                              label: "Otro...",
                              value: "__other__"
                            });
                            
                            this.setState({
                              countryOption: { label: 'México', value: 'MX' },
                              stateCustomer: { label: data.estado, value: data.estado },
                              cityCustomer: { label: data.municipio, value: data.municipio },
                              shippingNeighborhoodList: coloniasOptions,
                              selectedNeighborhoodOption: coloniasOptions[0],
                              zipcode: data.codigo_postal,
                            });
                          }
                        }}
                      />
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >
        
                       {this.state.stateCustomer?.label && (
                      <TextInput
                        id="stateCustomerReadonly"
                        s={12}
                        value={this.state.stateCustomer.label}
                        label="Estado"
                        readOnly
                      />
                    )}
                     {this.state.shippingNeighborhoodList?.length > 0 && (
                      <div style={{ marginBottom: "24px" }}>
                        <AsyncSelect
                          id="neighborhoodShippingOption"
                          value={this.state.selectedNeighborhoodOption}
                          cacheOptions={false}
                          defaultOptions={this.state.shippingNeighborhoodList}
                          loadOptions={(inputValue) => {
                            const normalizeText = (text) =>
                              text
                                .toLowerCase()
                                .normalize("NFD")
                                .replace(/[\u0300-\u036f]/g, "");

                            const filtered = this.state.shippingNeighborhoodList.filter(option =>
                              normalizeText(option.label).includes(normalizeText(inputValue))
                            );

                            return Promise.resolve(filtered);
                          }}
                          onChange={(selected) => {
                            if (selected.value === "__other__") {
                              this.setState({
                                selectedNeighborhoodOption: selected,
                                showCustomNeighborhood2: true,
                                customNeighborhood2: ""
                              });
                            } else {
                              this.setState({
                                selectedNeighborhoodOption: selected,
                                showCustomNeighborhood2: false,
                                customNeighborhood2: ""
                              });
                            }
                          }}
                        />
                      </div>
                    )}
                    
                    {this.state.showCustomNeighborhood2 && (
                      <TextInput
                        s={12}
                        label="Especifica la colonia"
                        value={this.state.customNeighborhood2}
                        onChange={(e) => {
                          const value = e.target.value;
                          this.setState({
                            customNeighborhood2: value,
                            selectedNeighborhoodOption: { label: value, value: value }
                          });
                        }}
                      />
                    )}

                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >
                    {this.state.cityCustomer?.label && (
                    <TextInput
                      id="cityOptionReadonly"
                      s={12}
                      value={this.state.cityCustomer.label}
                      label="Municipio"
                      readOnly
                    />
                  )}
                 
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{ display: !this.state.haveFiscalData || this.state.currentCustomer ? 'none' : '' }}
                  >     
                     
                  </Col>
                  <Col s={12} style={{ display: this.state.shipOnStore ? 'none' : '' }}>
                    <Row>
                      <Col l={4} m={6} s={7}>
                        <h4>Datos de Envío</h4>
                      </Col>
                      <Col
                        s={3}
                        style={{
                          display: !this.state.shipOnStore ? (!this.state.haveFiscalData ? 'none' : '') : 'none',
                        }}
                      >
                        <label> ¿Mismos que los Fiscales? </label>
                        <Switch
                          id="shipAddressHasFiscalCustomer"
                          onLabel={'Si'}
                          offLabel={'No'}
                          checked={this.state.shipAddressHasFiscal}
                          //onChange={(e) => this.setState({ shipAddressHasFiscal: e.target.checked })}
                          onChange={(e) => this.onToggleShipSameAsFiscal(e.target.checked)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{
                      display: this.state.shipOnStore
                        ? 'none'
                        : this.state.haveFiscalData && this.state.shipAddressHasFiscal
                        ? 'none'
                        : '',
                    }}
                  >
                    <TextInput
                      id="phoneShipping"
                      s={12}
                      type={'tel'}
                      value={this.state.phoneTwo}
                      label="Contacto de Envío"
                      onChange={(e) => this.setState({ phoneTwo: e.target.value })}
                    />
                    {this.state.currentCustomer == null && (
                      <TextInput
                        id="numberAddressCustomerShipping"
                        s={12}
                        value={this.state.numberAddressShipping || ''}
                        label="Número Exterior"
                        onChange={(e) => {
                          this.setState({ numberAddressShipping: e.target.value });
                        }}
                      />
                    )}
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{
                      display: this.state.shipOnStore
                        ? 'none'
                        : this.state.haveFiscalData && this.state.shipAddressHasFiscal
                        ? 'none'
                        : '',
                    }}
                  >
                    <TextInput
                      id="addressShippingCustomer"
                      s={12}
                      value={this.state.addressShipping}
                      label="Direcciónes"
                    
                      onChange={(e) => { this.setState({ addressShipping:  e.target.value }); }}
                    />
                    
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{
                      display: this.state.shipOnStore
                        ? 'none'
                        : this.state.haveFiscalData && this.state.shipAddressHasFiscal
                        ? 'none'
                        : '',
                    }}
                  >
                    <AddressForm
                      onChange={(data) => {
                        if (data) {
                          const coloniasOptions = data.colonias.map(c => ({
                            label: c,
                            value: c
                          }));
                          coloniasOptions.push({
                            label: "Otro...",
                            value: "__other__"
                          });

                          this.setState({
                            countryOption: { label: 'México', value: 'MX' },
                            stateOption: { label: data.estado, value: data.estado },
                            cityOption: { label: data.municipio, value: data.municipio },
                            neighborhoodList: coloniasOptions,
                            neighborhoodOption: coloniasOptions[0],
                            zipcode: data.codigo_postal,
                            
                            countryShippingOption: { label: 'México', value: 'MX' },
                            stateShippingOption: { label: data.estado, value: data.estado },
                            cityShippingOption: { label: data.municipio, value: data.municipio },
                            neighborhoodShippingOption: coloniasOptions[0],
                            zipcodeShipping: data.codigo_postal,
                          });
                          
                        }
                      }}
                    />
                  </Col>
                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{
                      display: this.state.shipOnStore
                        ? 'none'
                        : this.state.haveFiscalData && this.state.shipAddressHasFiscal
                        ? 'none'
                        : '',
                    }}
                  >
                   {this.state.stateOption?.label && (
                      <TextInput
                        id="stateShippingReadonly"
                        s={12}
                        value={this.state.stateOption.label}
                        label="Estado"
                        readOnly
                      />
                    )}
                    {this.state.neighborhoodList?.length > 0 && (
                    <div style={{ marginBottom: "24px" }}>
                    <AsyncSelect
                    id="neighborhoodOption"
                    value={this.state.neighborhoodOption}
                    cacheOptions={false}
                    defaultOptions={this.state.neighborhoodList}
                    loadOptions={(inputValue) => {
                      const normalize = (text) =>
                        text
                          .toLowerCase()
                          .normalize("NFD")
                          .replace(/[\u0300-\u036f]/g, "");

                      const filtered = this.state.neighborhoodList.filter(option =>
                        normalize(option.label).includes(normalize(inputValue))
                      );

                      return Promise.resolve(filtered);
                    }}
                    onChange={(selected) => {
                    if (selected.value === "__other__") {
                      this.setState({
                      neighborhoodOption: selected,
                      showCustomNeighborhood: true,
                      customNeighborhood: ""
                      });
                    } else {
                      this.setState({
                      neighborhoodOption: selected,
                      showCustomNeighborhood: false,
                      customNeighborhood: ""
                      });
                    }
                    }}
                    />
                    </div>
                    )}

                    {this.state.showCustomNeighborhood && (
                      <TextInput
                        s={12}
                        label="Especifica la colonia"
                        value={this.state.customNeighborhood}
                        onChange={(e) => {
                          const value = e.target.value;
                          this.setState({
                            customNeighborhood: value,
                            neighborhoodOption: { label: value, value: value }
                          });
                        }}
                      />
                    )}

                  </Col>

                  <Col
                    s={12}
                    l={6}
                    className="p-bottom"
                    style={{
                      display: this.state.shipOnStore
                        ? 'none'
                        : this.state.haveFiscalData && this.state.shipAddressHasFiscal
                        ? 'none'
                        : '',
                    }}
                  >
                 {this.state.cityOption?.label && (
                    <TextInput
                      id="cityShippingReadonly"
                      s={12}
                      value={this.state.cityOption.label}
                      label="Municipio"
                      readOnly
                    />
                  )}

                 
                  </Col>
                </Row>
              </Col>
            </Row>

            <div>
              <Row>
                {this.state.currentCustomer && this.props.user && canEdit && (
                  <>
                    <Col s={12}>
                      <h4
                        style={{
                          fontSize: isGerencia ? '22px' : '18px',
                          fontWeight: 'bold',
                        }}
                      >
                        Detalles Comerciales
                      </h4>
                    </Col>

                    <>
                      <Col s={12} l={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                          {canEdit ? (
                            <TextInput
                              id="Potential"
                              label="Potencial del Cliente"
                              value={String(this.state.potential)}
                              onChange={(e) => this.setState({ potential: e.target.value })}
                            />
                          ) : (
                            <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '0' }}>
                              Potencial del Cliente: {String(this.state.potential || '')}
                            </p>
                          )}
                        </div>
                      </Col>

                      <Col s={12} l={4}>
                        {canEdit ? (
                          <>
                            <TextInput
                              id="lastVisitDateInput"
                              label="Última Visita"
                              value={(() => {
                                const d =
                                  this.state.lastVisitDate instanceof Date
                                    ? this.state.lastVisitDate
                                    : new Date(this.state.lastVisitDate);
                                const nd = new Date(d.getFullYear(), d.getMonth(), d.getDate());
                                const y = nd.getFullYear();
                                const m = String(nd.getMonth() + 1).padStart(2, '0');
                                const day = String(nd.getDate()).padStart(2, '0');
                                return `${y}-${m}-${day}`;
                              })()}
                              onFocus={() => {
                                const picker = M.Datepicker.init(
                                  document.getElementById('lastVisitDateHidden'),
                                  {
                                    autoClose: true,
                                    defaultDate: this.state.lastVisitDate || new Date(),
                                    format: 'yyyy-mm-dd',
                                    maxDate: new Date(),
                                    onSelect: (date) => this.setState({ lastVisitDate: date }),
                                  }
                                );
                                picker.open();
                              }}
                              readOnly
                            />
                            <input type="text" id="lastVisitDateHidden" style={{ display: 'none' }} />
                          </>
                        ) : (
                          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            Última Visita:{' '}
                            {this.state.lastVisitDate
                              ? new Date(this.state.lastVisitDate).toISOString().split('T')[0]
                              : ''}
                          </p>
                        )}
                      </Col>

                      <Col s={12} l={4}>
                        {isGerencia ? (
                          <AsyncSelect
                            id="territorySelect"
                            placeholder="Territorio"
                            cacheOptions
                            isClearable
                            value={this.state.territoryOption}
                            onChange={(value) => {
                              this.setState({ territoryOption: value });
                            }}
                            loadOptions={this.loadTerritories}
                            defaultOptions={true}
                            noOptionsMessage={() => 'No se encontraron territorios'}
                          />
                        ) : (
                          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            Territorio: {this.state.territoryOption?.label || 'Sin territorio'}
                          </p>
                        )}
                      </Col>
                    </>
                  </>
                )}
              </Row>

              <Row>
                <Col s={12} className="left-align">
                  {(!this.state.currentCustomer || (this.state.currentCustomer && canEdit)) && (
                    <Button
                      className="m3"
                      node="button"
                      waves="light"
                      style={{ zIndex: 0 }}
                      disabled={this.state.buttonDisabled}
                      onClick={() => {

                        if (this.state.rfcClient && this.state.rfcClient.length > 0) {

                          Swal.fire({
                            title: "RFC ya registrado",
                            text: "Ya existe un cliente con este RFC",
                            icon: "warning",
                            button: "Aceptar"
                          });

                          return;
                        }

                        this.setState({ buttonDisabled: true }, () => {
                          this.handleCreateCustomer();

                          setTimeout(() => {
                            this.setState({ buttonDisabled: false });
                          }, 10000);
                        });

                      }}
                    >
  {this.state.buttonDisabled
    ? 'Procesando...'
    : this.state.currentCustomer
    ? 'Actualizar'
    : 'Crear'} Cliente
</Button>
                  )}
                </Col>
              </Row>
            </div>  
          </Container>
        </Modal>
      </React.Fragment>
    );
  }
}

export { ModalNewCustomer as default };